import React from 'react';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import ProfileAvatar from 'components/lib/profile_avatar';

export function CustomerProfileAvatar({ className, name, image }) {
  return <ProfileAvatar wrapperClassName={className} profile={{ name, image }} />;
}

CustomerProfileAvatar.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
};

const CustomerProfileAvatarContainer = connect(mapStateToProps)(CustomerProfileAvatar);

function mapStateToProps({ getProvider }) {
  let profile = getProvider('profile').get();
  return {
    name: profile && profile.name,
    image: profile && profile.getImageUrl(),
  };
}

export default CustomerProfileAvatarContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/customer_profile_avatar.jsx